import * as EditorialContentAction from "./creators/editorialContentCreator"
import { Logger } from "@ng-mw/shared-react-components"
import { Dispatch } from "redux"
import { fetchKundeavis } from "@modules/editorial-content/api/getCampaignPaper"
import { buildEditorialContent } from "./buildEditorialContent"

// NOTE: This "EditorialContent" slice currently powers MENY's "Utforsk" blocks.
// MENY only needs 2 blocks for now (Campaign Paper + Opening Hours) and may remove them later.
// We keep the existing ContentBlockItem[] shape; campaign URL comes from `/common/kundeavis`.

export const getEditorialContent = () => {
    return async (dispatch: Dispatch) => {
        dispatch(EditorialContentAction.getAllEditorialContentLoading())

        try {
            const kundeavis = await fetchKundeavis()
            const content = buildEditorialContent(kundeavis)

            dispatch(EditorialContentAction.getAllEditorialContentSuccess(content))
        } catch (error) {
            dispatch(EditorialContentAction.getAllEditorialContentError(error))
            Logger.error("actions/EditorialContent/getEditorialContent()", error)
        } finally {
            dispatch(EditorialContentAction.getAllEditorialContentLoaded())
        }
    }
}

export const updateEditorialContentStore = (data: any) => {
    return async (dispatch: Dispatch) => {
        dispatch(EditorialContentAction.updateEditorialContentStore(data))
    }
}
